import React, { Component } from 'react';
import Moment from 'moment';
import 'moment-timezone';
import TimeslotPicker from './timeslotPicker';
import DateRangePicker from 'react-daterange-picker';
import _ from 'underscore';
import ReactModal from 'react-modal';
import { browserHistory } from 'react-router';

const stateDefinitions = {
    available: {
        color: null,
        label: 'Available',
    },
    unavailable: {
        selectable: false,
        color: '#8a8a8a',
        label: 'Unavailable',
    },
};

class BookingWizardPickDateQuick extends Component {
    constructor(props) {
        super(props);
        this.onQuickSelect = this.onQuickSelect.bind(this);
        this.onDateSelect = this.onDateSelect.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.hideTentativeModal = this.hideTentativeModal.bind(this);
        this.handleContactUs = this.handleContactUs.bind(this);
        
        let availableDays = this.massageAvailableDays(this.props.booking.bookingAvailability.availableDays);

        let availableSessions = this.props.booking.bookingAvailability.bookingSessions;

        this.state = {
            selectedDate:null,
            availableDays: availableDays,
            availableSessions: availableSessions,
            maximumDate: Moment().add(4, "months").toDate(),
            calendarAvailableRange: this.getCalendarAvailableDays(availableDays),
            showModal: false,
            dismissedTentativeModal: false
        };
    }

    massageAvailableDays(availabledaysFromServer) {
        return availabledaysFromServer.map(function (availableDay) {
            return { date: Moment(availableDay.theDate), canSelfBook: availableDay.canSelfBook };
        });
    }

    getSelectedDay(selectedDate) {
        return _.find(this.state.availableDays, (day) => selectedDate.toString() == day.date.toString());
    }

    getCalendarAvailableDays(availabledaysFromServer) {
        const returnArray = [];

        availabledaysFromServer.map(function ({ date }) {
            returnArray.push({
                state: 'available',
                range: Moment.range(date, date)
            });
        });
        
        return returnArray;
    }

    onQuickSelect(selectedDate, selectedTimeslot, confirmBooking, event) {
        const { onBookingDataSelection, onSubmit, booking } = this.props;

        if (confirmBooking || this.getSelectedDay(selectedDate).canSelfBook) {
            onBookingDataSelection('date', selectedDate);
            onBookingDataSelection('timeslot', selectedTimeslot);

            if (confirmBooking)
                onBookingDataSelection('notesBooking', "Merchant confirmed booking as scheduled.");
            else if (booking.details.isProjectUpgrade) {
                const timeslot = _.find(this.state.availableSessions, (s) => s.sessionId == selectedTimeslot);
                onBookingDataSelection('notesBooking', "Merchant has rebooked for " + selectedDate.format("DD/MM/YYYY") + " " + timeslot.displayText + ".");
            }

            onSubmit(event);
        }
        else {
            this.setState({ 
                selectedDate: selectedDate,
                showModal: true 
            });
        }
    }

    onDateSelect(range, states) {
        this.setState({
            selectedDate: range,
            state: states,
            showModal: !this.getSelectedDay(range).canSelfBook
        });
    }

    hideModal() {
        this.setState({ 
            selectedDate: null,
            showModal: false 
        });
    }

    hideTentativeModal() {
        this.setState({
            dismissedTentativeModal: true
        });
    }

    handleContactUs() {
        browserHistory.push(`/contactus/incorrectdetails/${this.props.params.jobId}`);
    }

    handleChange = (item, value) => {
        this.setState({ ...this.state, [item]: value });
    }

    render() {
        const selectedDate = this.state.selectedDate ? this.state.selectedDate.format("dddd, Do MMMM") : "";
        let { isProjectUpgrade, bookForDateTime } = this.props.booking.details;

        return (
            <div>
                <h2 className="client-text">
                    When should we perform the {isProjectUpgrade ? "upgrade" : "installation"}?
                </h2>
                <TimeslotPicker availableSessions={this.state.availableSessions} onQuickSelect={this.onQuickSelect} date={this.state.availableDays[0].date} />
                <TimeslotPicker availableSessions={this.state.availableSessions} onQuickSelect={this.onQuickSelect} date={this.state.availableDays[1].date} />
                <TimeslotPicker availableSessions={this.state.availableSessions} onQuickSelect={this.onQuickSelect} date={this.state.availableDays[2].date} />

                <div className="row">
                    <div className="col-md-12">
                        <div className="card-slim text-center">
                            <p><i className="fa fa-calendar" /> Another Time...</p>
                            <div className="row">
                                <DateRangePicker
                                    firstOfWeek={1}
                                    numberOfCalendars={1}
                                    selectionType="single"
                                    minimumDate={new Date()}
                                    maximumDate={this.state.maximumDate}
                                    stateDefinitions={stateDefinitions}
                                    dateStates={this.state.calendarAvailableRange}
                                    defaultState="unavailable"
                                    showLegend={true}
                                    value={this.state.selectedDate}
                                    onSelect={this.onDateSelect} />
                            </div>
                            <TimeslotPicker availableSessions={this.state.availableSessions} onQuickSelect={this.onQuickSelect} disabled={!this.state.selectedDate} date={this.state.selectedDate || Moment()} compact={true} />
                        </div>
                    </div>
                </div>

                <ReactModal isOpen={this.state.showModal} className="modal" overlayClassName="ReactModal__Overlay" bodyOpenClassName="modal-open" onRequestClose={this.hideModal} ariaHideApp={false}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" aria-label="Close" onClick={this.hideModal}><span aria-hidden="true">&times;</span></button>
                                <h4 className="modal-title">Self-Booking Unavailable</h4>
                            </div>
                            <div className="modal-body">
                                <p>If you wish to proceed with booking the installation for this day ({selectedDate}), please contact us.</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-client" onClick={this.hideModal}>Try another day...</button>
                                <button type="button" className="btn btn-client-alt" onClick={this.handleContactUs}>Contact Us</button>
                            </div>
                        </div>
                    </div>
                </ReactModal>

                <ReactModal isOpen={isProjectUpgrade && !this.state.dismissedTentativeModal} className="modal" overlayClassName="ReactModal__Overlay" bodyOpenClassName="modal-open" onRequestClose={this.hideTentativeModal} ariaHideApp={false}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" aria-label="Close" onClick={this.hideTentativeModal}><span aria-hidden="true">&times;</span></button>
                                <h4 className="modal-title">Confirm Booking</h4>
                            </div>
                            <div className="modal-body">
                                <p>Your upgrade is scheduled for the week Monday to Friday ({Moment(bookForDateTime).format("dddd, Do MMMM")}).</p>
                            </div>
                            <div className="modal-footer">
                                
                            <button type="button" className="btn btn-client" onClick={(event) => this.onQuickSelect(Moment(bookForDateTime), 1, true, event)}>Confirm</button>
                                <button type="button" className="btn btn-client-alt" onClick={this.hideTentativeModal}>Pick another time...</button>
                            </div>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    }
}

export default BookingWizardPickDateQuick;


// WEBPACK FOOTER //
// ./app/booking/components/bookingWizardPickDateQuick.js